import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Row, Col, Container, Button } from 'reactstrap';
import { CollapseItemTableIndicator } from "../../comum/components/CollapseItemTableIndicator";
import DetalhesCargaGeral from "./DetalhesCargaGeral";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingImage from "../../comum/components/LoadingImage";
import Checkbox from '../../comum/components/Checkbox'
import Tooltip from "../../comum/components/Tooltip";
import { HeaderTableFixed } from "../../../utils/headerTableFixed";
import CargaGeralCard from "./CargaGeralCard";

@inject("store")
@observer
export class TabelaCargaGeralAcompanhamento extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controller = this.props.controller;
        
        window.addEventListener('scroll', HeaderTableFixed);
    };

    addCol = () => {
        this.controller.colunas.push({
            dataField: 'inativar2',
            isDummyField: true,
            text: this.controller.superCheck,
            formatter: (cell, row) => {
                return <Checkbox onClick={() => this.controller.marcar(row)} ativo={row.marcado} />
            },
            cardFormatter: (cell, row) => {
                return <Row>
                    <Col sm={12}>
                        <Button className="btn-com-bordas-primary" onClick={() => this.controller.marcar(row)} >Inativar</Button>
                    </Col>
                </Row>
            }
        })
    };

    render() {
        // const detalhesRow = {
        //     renderer: row => (
        //         <Row>
        //             <DetalhesCargaGeral titulo="Outros dados" colunas={this.controller.colunas} row={row} />
        //         </Row>
        //     ),
        //     showExpandColumn: true,
        //     expandByColumnOnly: true,
        //     expandHeaderColumnRenderer: () => "Detalhes",
        //     onExpandAll: (isExpandAll, results, e) => {
        //         e.PreventDefault();
        //     },
        //     expandColumnPosition: 'right',
        //     expandColumnRenderer: ({ expanded }) => {
        //         return (
        //             <CollapseItemTableIndicator expanded={expanded} />
        //         );
        //     }
        // };

        const selectRow = {
            mode: 'checkbox',
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                    <Checkbox ativo={rest.checked} onClick={() => { }} />
                </Tooltip>
            ),
            selectionRenderer: ({ mode, ...rest }) =>
                <Checkbox ativo={rest.checked} onClick={() => { }} />,
            onSelect: (row, isSelect, rowIndex, e) => {
                e.preventDefault()
                e.stopPropagation()
                this.controller.marcar(row)
            },
            onSelectAll: (isSelect, rows, e) => {
                e.preventDefault()
                e.stopPropagation()
                while (this.controller.hasMore) {
                    this.controller.loadNextTurn()
                }

                this.controller.marcarTodas(isSelect)
                if (isSelect) {
                    const selecao = this.controller.itens.map((item, index) => {
                        return item.Id
                    })
                    return selecao
                } else {
                    return []
                }
            },
        }

        return (
            <Container fluid className="tabela-container">
                {this.controller.loading ? <LoadingImage />

                    : <React.Fragment>
                        {(!this.controller.cargasLista.length > 0)
                            ? <Row>
                                <Col xs={12}>
                                    <span className="mensagem-filtrar">
                                        {this.controller.tableMessage}
                                    </span>
                                </Col>
                            </Row>
                            :

                            <InfiniteScroll
                                dataLength={this.controller.itens.length}
                                next={() => this.controller.loadNextTurn()}
                                hasMore={this.controller.hasMore}
                                loader={<LoadingImage />}
                            >
                                <ToolkitProvider
                                    keyField="Id"
                                    data={[...this.controller.itens]}
                                    columns={[...this.controller.colunas]} >
                                    {props => (
                                        <div>
                                             {window.innerWidth > 991
                                            ? 
                                                <div id="tableHeaderFixed" className="tabela-overflow">
                                                    <BootstrapTable bootstrap4
                                                        striped
                                                        bordered={false}
                                                        noDataIndication={() => this.controller.noData}
                                                        classes="tabela tabela-layout cabotagem"
                                                        selectRow={selectRow}
                                                        {...props.baseProps} />
                                                </div>
                                                
                                                : <Row>
                                                {this.controller.itens.map((card, x) => (
                                                    <CargaGeralCard
                                                        controller={this.controller}
                                                        key={x}
                                                        data={card}
                                                        id={x}
                                                        click={this.controller.marcar}
                                                        colunas={[...this.controller.colunas]}
                                                        outrosDados={[...this.controller.outrosDados]}
                                                        titulo={"NavioNome"}
                                                        subtitulo={"Viagem"}

                                                    />
                                                ))}
                                            </Row>
                                        }
                                        </div>)
                                    }
                                </ToolkitProvider>
                            </InfiniteScroll>}
                    </React.Fragment>}

            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/TabelaCargaGeralAcompanhamento.js